<div class="link-container">
    <div class="link-content">
      <!-- With Link and Tooltip -->
      <rad-tooltip
        *ngIf="hasLink && hasTooltip"
        #radTooltip
        [attr.tooltip-label]="tooltipText"
        [attr.tooltip-placement]="tooltipPosition">
        <rad-link 
          [attr.href]="linkUrl" 
          [attr.target]="target"
          [attr.external]="isExternal ? 'true' : null"
          [appShadowStyle]="linkStyle">
          {{ linkText }}
        </rad-link>
      </rad-tooltip>
  
      <!-- With Link, No Tooltip -->
      <rad-link
        *ngIf="hasLink && !hasTooltip"
        [appShadowStyle]="linkStyle"
        [attr.href]="linkUrl" 
        [attr.target]="target"
        [attr.external]="isExternal ? 'true' : null">
        {{ linkText }}
      </rad-link>
  
      <!-- No Link, With Tooltip -->
      <rad-tooltip
        *ngIf="!hasLink && hasTooltip"
        #radTooltip
        [attr.tooltip-label]="tooltipText"
        [attr.tooltip-placement]="tooltipPosition">
        <div class="plain-text">
          {{ linkText }}
        </div>
      </rad-tooltip>
  
      <!-- No Link, No Tooltip -->
      <div
        *ngIf="!hasLink && !hasTooltip"
        class="plain-text">
        {{ linkText }}
      </div>
    </div>
  
    <div class="popover-container" *ngIf="hasPopover" (click)="onPopoverClick($event)">
      <lib-popover
            class="lib-popover"
            popoverSize="extra-large"
            popoverType="async"
            popoverPlacement="right"
            [popoverAsyncContent]="popoverRunDetails"
            (shown)="onPopoverShown()"
        ></lib-popover>
    </div>
  
      <ng-template #popoverRunDetails>
        <lib-progress 
          #popoverLoadingSpinner
          [hidden]="!(isLoading$ | async)"
          [loader]="false"
          [spinner]="true"
          spinnerPosition="center">
        </lib-progress>

        <div *ngIf="!(isLoading$ | async)">
          <h4 class="lib-popover__header">Biosample Details</h4>
          <div class="yield-info">
            <span class="yield-label">Actual Yield:</span>
            <span class="yield-value">{{ actualYield }}</span>
          </div>

          <h4 class="lib-popover__header" style="display: flex; align-items: center; gap: 4px;">
            <span>Recent Fastq Dataset Details</span>
            <app-popover-info-icon
              [popoverAppendTo]="null"
              popoverPlacement="right"
            >Only FASTQ datasets without failure statuses will be used, and are displayed below.
            </app-popover-info-icon>
          </h4>
          
          <div class="table-wrapper">
            <lib-data-table
              [rowData]="datasetsTableData"
              [gridOptions]="gridOptions"
              [showColumnsSwitcher]="'disable'"
              [showPageSizeController]="'disable'"
            ></lib-data-table>
          </div>
        </div>
      </ng-template>
  </div>
  